import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {PopoverMultiSelectObjectBaseComponent} from '../_base/popover-multi-select-object-base.component';
import {Device, DeviceId, DeviceType} from '../../../../../shared/models/device';
import {DevicesService} from '../../../../../core/services/devices.service';
import {Option, OptionGroupMultiSelect} from '../../../../../shared/models/option';
import {Observable} from 'rxjs';
import {PopoverMultiSelectComponent} from '../../popover-multi-select.component';

@Component({
  selector: 'motn-popover-select-devices',
  templateUrl: './popover-select-devices.component.html',
  styleUrls: ['./popover-select-devices.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PopoverMultiSelectComponent,
  ],
})
export class PopoverSelectDevicesComponent extends PopoverMultiSelectObjectBaseComponent implements OnInit {
  @Input() preselectedDevices: DeviceId[];
  /**
   * Optional. Supply if there should only be a subset of devices smaller than all the
   * user's devices to select from.
   */
  @Input() devices: Device[];
  /**
   * Optional. When provided, only devices with a matching Type will be shown.
   */
  @Input() allowedTypes: DeviceType[];


  constructor(
    private devicesService: DevicesService,
  ) {
    super();
  }


  onSelectDevice($event: Option) {
    if ($event) {
      this.clickedOption$.emit($event);
    }
  }


  protected onInit() {
    this.optionGroup$ = new Observable<OptionGroupMultiSelect>(
      subscriber => {
        if (this.optionGroupIsPrepared()) {
          this.initSubscriberHandle(subscriber);
        } else if (!this.devices) {
          this.devicesService.fetchUserDevices$().subscribe({
            next: (devices) => {
              this.devices = devices;

              this.prepareOptionGroup();
              this.initSubscriberHandle(subscriber);
            },
            error: err => subscriber.error(err),
          });
        } else {
          this.prepareOptionGroup();
          this.initSubscriberHandle(subscriber);
        }
      },
    );
  }


  protected prepareOptionGroup(): OptionGroupMultiSelect {
    const options: Option[] = [];
    const devices = this.allowedTypes?.length
      ? this.devices.filter(d => this.allowedTypes.includes(d.Type as DeviceType))
      : this.devices;

    for (let device of devices) {
      const selected = !!this.preselectedDevices?.includes(device.ID);

      options.push({
        id: '' + device.ID,
        name: device.Name,
        selected: selected,
        pill: {
          letter: 'd',
          text: device.ID,
        },
      });
    }

    return this.optionGroup = new OptionGroupMultiSelect(options);
  }
}
